module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-0aaac4992e713b3ed10b0bb96999bea9.png";